export const environment = {
  apiUrl: 'https://api.tlm.dev.core.frb.eventim.cloud',
} as const;
